import request from '@/router/axios'

export function getSysConfig () {
  return request({
    url: 'http://47.92.102.238:8080/system/config/getSysConfig',
    // url: 'http://api.exam.chineseall.cn:8081/system/config/getSysConfig',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/sys.js